import OpenOfficeImg from "../assets/svg/openoffice.svg";
import PrivateOfficeImg from "../assets/svg/privateoffice.svg";
import CollaborativeSpaceImg from "../assets/svg/collaborationspace.svg";
//import PhoneBoothImg from '../assets/svg/phonebooth.svg';

const workspaceData = [
  {
    title: "workspace_open_office_title",
    imgSrc: OpenOfficeImg,
    requiresPeople: true,
    placeholder: "0",
    tooltipText: "workspace_open_office_tooltip",
  },
  {
    title: "workspace_private_office_title",
    imgSrc: PrivateOfficeImg,
    requiresPeople: true,
    placeholder: "0",
    tooltipText: "workspace_private_office_tooltip",
  },
  {
    title: "workspace_collaborative_space_title",
    imgSrc: CollaborativeSpaceImg,
    requiresPeople: true,
    placeholder: "0",
    tooltipText: "workspace_collaborative_space_tooltip",
  },
  /*{
    title: 'workspace_phone_booth_title',
    imgSrc: PhoneBoothImg,
    requiresPeople: true,
    placeholder: '1',
    tooltipText: 'workspace_phone_booth_tooltip',
  },*/
];

export default workspaceData;
